module.exports = __webpack_public_path__ + "static/img/NSW-26.7bdbcd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-26.jpg
// module id = Bvbo
// module chunks = 0